export default {
  "80/20": {
    name: "80/20",
  },
  "McMaster": {
    name: "McMaster-Carr ",
  }
}